<span>{{ showMore ? sitecore.event.ShowMore : sitecore.event.ShowLess }}</span>
<ng-container *ngIf="showMore">
    <span class="more-counter" *msShowInEpcot="false"> ({{ remainingCounter }}) </span>
</ng-container>

<vn-icon name="theme-right" size="16"></vn-icon>
